import React from 'react';
import { connect } from "react-redux";
import './App.css';
import './Global/style.css'
import Main from './Main.js'
import clientDevices from './API/Client/GetDevices'
import clientBusinessPremises from './API/Client/BusinessPremises'
import clientInfo from './API/Client/GetClientInfo'
import Axios from 'axios'
import logout from './Global/logout'
import Loader from './Global/loader'
import checkJwt from './Global/jwtChecker'

class App extends React.Component{
    state = {
      refresh: true,
      pathname: ""
    }

    componentDidMount = async () => {
        Axios.defaults.baseURL = process.env.REACT_APP_BASE_URL

        // if user refreshes check if he is still valid 
        const token = sessionStorage.getItem("token")
        if(token !== null){

            await this.props.mapState("USER_MAP_JWT", token)
            
            const unhashedJwt = await checkJwt()

            //check if admin
            if(unhashedJwt.role === "admin"){
                //map role
                await this.props.mapState("USER_MAP_ROLE", "admin")
            }
            else{
              //role client is mapped by default
              //map devices if token is valid
                const devices = await clientDevices()            
                if(!devices.error){              
                    await this.props.mapState("CLIENT_MAP_DEVICES", devices)
                }
                else(                
                    await logout()
                )

                //map business premesis if token is valid
                const businesssPremises = await clientBusinessPremises()
                if(!businesssPremises.error){
                    await this.props.mapState("CLIENT_MAP_BUSSINES_PREMISES", businesssPremises)
                }
                else(                
                    await logout()
                )

                const clientCredentials = await clientInfo()
                if(clientCredentials.error){
                    await logout()
                }
                else{              
                    this.props.mapState("USER_MAP_CREDENTIALS", clientCredentials.data)
                }
            }

            
            
        }

        this.setState({refresh:false})
    }


    render() {
        return( 
            <div style={{height: "inherit"}}> 
                {this.state.refresh ?
                    <Loader />
                :
                    <Main />
                }
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({type: type, data: data})
    };
};
  
const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
        jwtToken: state.user.jwtToken
    };
};
  
export default 
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
(App);